/**
 * Hero Section Animation Logic - Production Ready (ScrollSmoother Integrated)
 */

document.addEventListener("DOMContentLoaded", () => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        console.warn("GSAP / ScrollTrigger not found. Animation aborted.");
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const heroes = document.querySelectorAll('.wp-block-osmerova-hero-section-advanced');

    heroes.forEach((hero) => {
        // --- Typography Fix (Orphans & Widows) ---
        const headline = hero.querySelector('h1');
        if (headline) {
            headline.innerHTML = headline.innerHTML.replace(/\s(k|s|v|z|o|u|i|a|pro)\s/gi, ' $1&nbsp;');
        }

        const textElements = hero.querySelectorAll('.is-style-headline, h1, h4');
        const imageWrapper = hero.querySelector('.wp-block-image');

        // Inicializácia GSAP matchMedia pre tento konkrétny Hero blok
        let mm = gsap.matchMedia(hero);

        // 1. SPOLOČNÉ ANIMÁCIE (Všetky zariadenia)
        mm.add("all", () => {
            const introTl = gsap.timeline({defaults: {ease: "power3.out"}});

            if (textElements.length) {
                introTl.from(textElements, {
                    y: 40,
                    autoAlpha: 0,
                    duration: 1.2,
                    stagger: 0.15
                });
            }

            if (imageWrapper) {
                introTl.from(imageWrapper, {
                    autoAlpha: 0,
                    y: 30,
                    duration: 1.5,
                    ease: "power2.out"
                }, "-=0.8");
            }
        });

        // 2. DESKTOP ANIMÁCIA (Scrollovanie a zmena orezu)
        mm.add("(min-width: 769px)", () => {
            if (imageWrapper) {
                const getClipEdge = () => {
                    const viewportWidth = window.innerWidth;
                    const contentWidth = Math.min(viewportWidth - 48, 800);
                    return (viewportWidth - contentWidth) / 2;
                };

                gsap.fromTo(imageWrapper,
                    {
                        clipPath: () => `inset(0px ${getClipEdge()}px 0px ${getClipEdge()}px)`
                    },
                    {
                        clipPath: "inset(0px 0px 0px 0px)",
                        ease: "none",
                        scrollTrigger: {
                            trigger: imageWrapper,
                            start: "top bottom",
                            end: "center center",
                            scrub: true,
                            invalidateOnRefresh: true
                        }
                    }
                );
            }
        });

        // 3. MOBILNÉ ZARIADENIA (Statický obrázok pre stabilitu pri zoome)
        mm.add("(max-width: 768px)", () => {
            if (imageWrapper) {
                // Vynútime zrušenie akéhokoľvek orezania z CSS, aby bol obrázok okamžite na 100%
                gsap.set(imageWrapper, {
                    clipPath: "inset(0px 0px 0px 0px)"
                });
            }
        });

    });
});
